import { isNarrationMuted, setNarrationMuted } from './narrationPref.js';

export interface NarrationBanner {
  element: HTMLElement;
  show(note: string): void;
  setMuted(muted: boolean): void;
}

/** Fixed bottom caption strip for the agent's per-action reasoning. Honors the
 *  per-device mute pref; includes a small mute toggle. Mount-on-create. */
export function createNarrationBanner(): NarrationBanner {
  const el = document.createElement('div');
  el.hidden = true;
  el.style.cssText = `position:fixed;left:0;right:0;bottom:0;z-index:9500;display:flex;gap:8px;align-items:center;
    padding:10px 14px;font-family:sans-serif;font-size:14px;color:#e8e8e8;background:rgba(6,20,14,0.92);border-top:1px solid #d4af37;`;

  const text = document.createElement('div');
  text.style.cssText = 'flex:1;line-height:1.3;';

  const toggle = document.createElement('button');
  toggle.style.cssText = 'background:none;border:1px solid #d4af37;color:#d4af37;border-radius:6px;padding:4px 8px;font-size:12px;cursor:pointer;';
  const renderToggle = () => { toggle.textContent = isNarrationMuted() ? 'Narration: off' : 'Narration: on'; };
  toggle.addEventListener('click', () => api.setMuted(!isNarrationMuted()));

  el.appendChild(text);
  el.appendChild(toggle);
  document.body.appendChild(el);
  renderToggle();

  const api: NarrationBanner = {
    element: el,
    show(note: string) {
      text.textContent = note;
      el.hidden = isNarrationMuted() || note.trim().length === 0;
    },
    setMuted(muted: boolean) {
      setNarrationMuted(muted);
      renderToggle();
      if (muted) el.hidden = true;
    },
  };
  return api;
}

/** Extract the agent's reasoning note off an applied engine-input event, if any. */
export function noteFromEvent(event: { type: string; [k: string]: unknown }): string | null {
  const n = (event as { note?: unknown }).note;
  return typeof n === 'string' && n.length > 0 ? n : null;
}
